<template>
  <div class="musicLeft">
    <div class="left-item" @click="addSmartVoice" v-if="timeBarType == 'dub'">
      <div class="cu-po uploadMusic iconpeiyin iconfont"></div>
      <span>仿真配音</span>
    </div>
    <div class="left-item" @click="openRecord" v-if="timeBarType == 'dub'">
      <div class="cu-po uploadMusic iconfont iconluyin"></div>
      <span>录音</span>
    </div>
    <div class="left-item">
      <label style="height: 100%; width: 100%" for="audio">
        <div class="cu-po uploadMusic">
          <span class="iconfont iconshangchuan"></span>
        </div>
        <span>上传</span>
      </label>
    </div>
    <div class="uploadItem">
      <p class="uploadTitle">上传标准</p>
      <div class="uploadTips">
        <div>支持格式:<br />mp3,m4a,wav,<br />aac,amr,<br />大小不超过20M</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "music-library-left",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      timeBarType: "addSoundtrack/getTimeBarType",
      receiveData: "addSoundtrack/getReceiveData"
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    addSmartVoice() {
      this.$store.commit("addSoundtrack/setSoundtrackState", { state: false });
      this.$store.commit("smartVoice/setSmartVoiceDialogVisible", true);
    },
    async openRecord() {
      let error = "";
      let start = 0;
      if (!window.navigator.mediaDevices) {
        error = "noFunction";
      } else {
        let stream = await window.navigator.mediaDevices
          .getUserMedia({ audio: true })
          .catch((err) => {
            error = err.name;
            return null;
          });
        if (stream) {
          stream.getTracks()[0].stop();
        }
      }
      if(!error) {
        start = this.receiveData.start;
      }
      this.$bus.emit("open-record-preview", { error, start });
      this.$store.commit("addSoundtrack/setSoundtrackState", { state: false });
    },
  },
};
</script>

<style scoped lang="scss">
.musicLeft {
  width: 84px;
  height: 100%;
  float: left;
  padding-top: 10px;
  background-color: #d9ddea;
  .iconfont {
    font-size: 22px;
    color: #474261;
  }
  span {
    color: #606266;
    font-size: 13px;
  }
  .left-item {
    &:hover {
      .uploadMusic {
        border: 1px solid #5778fb;
        color: #5778fb;
      }
      span {
        color: #5778fb;
      }
    }
  }
  .uploadMusic {
    width: 48px;
    height: 48px;
    background: #ffffff;
    border-radius: 8px;
    line-height: 48px;
    margin: 30px auto 0;
  }
  .uploadItem {
    position: relative;
    &:hover {
      .uploadTips {
        display: block;
      }
    }
    .uploadTips {
      display: none;
      position: absolute;
      top: 20px;
      left: 5px;
      z-index: 999;
      background-color: rgba($color: #000000, $alpha: 0.5);
      width: 108px;
      font-size: 12px;
      text-align: left;
      padding: 10px;
      color: #ffffff;
      border-radius: 4px;
    }
    .uploadTitle {
      text-decoration: underline;
      color: #a5a7c6;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/soundtrack/musicLibraryleft.vue